// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from 'react-localized'
import { IonItem, IonItemGroup, IonLabel, IonList, IonNote, IonSegment, IonSegmentButton } from '@ionic/react'
import zoneinfo from './zoneinfo.json'
import { useState } from 'react'


interface TimezoneSelectorProps {
  children?: React.ReactNode
  onSelected(code: string): void
  value?: string
}


const localeZone: string | undefined = Intl.DateTimeFormat().resolvedOptions().timeZone
const defaultZone: string = (zoneinfo.includes(localeZone)) ? localeZone : "Europe/Amsterdam"


const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({children, ...props}) => {
  const {gettext} = useLocales()
  const [continent, setContinent] = useState<string | undefined>(undefined)
  const onSelected: (zone: string) => void = (zone) => {
    props.onSelected(zone)
  }
  return (
    <>
      <IonList>
        <IonItem
          detail
          onClick={() => onSelected(props.value || defaultZone)}
          style={{cursor: "pointer", marginBottom: "11px"}}
        >
          <IonLabel>{props.value || defaultZone}</IonLabel>
          <IonNote slot="helper">{gettext("Tik om verder te gaan.")}</IonNote>
        </IonItem>
        <IonItem lines="none">
          {children}
        </IonItem>
      </IonList>
      <IonList style={{paddingTop: "0px"}}>
        <IonItem lines="none" style={{"--padding-start": "20px"}}>
          <IonLabel><h2 style={{fontSize: "18px"}}>{gettext("Meer tijdzones")}</h2></IonLabel>
        </IonItem>
        <IonItem lines="none">
          <IonSegment value={continent} onIonChange={(event) => setContinent(event.detail.value || undefined)}>
            <IonSegmentButton value="Africa">
              <IonLabel>{gettext("Afrika")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="America">
              <IonLabel>{gettext("Amerika")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="Asia">
              <IonLabel>{gettext("Azië")}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonItem>
        <IonItem lines="none">
          <IonSegment value={continent} onIonChange={(event) => setContinent(event.detail.value || undefined)}>
            <IonSegmentButton value="Europe">
              <IonLabel>{gettext("Europa")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="Pacific">
              <IonLabel>{gettext("Oceanië")}</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="Etc">
              <IonLabel>{gettext("Overig")}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonItem>
        <IonItemGroup>
          {zoneinfo
            .filter((zone) => {return (!continent) ? zone : zone.startsWith(continent)})
            .map((zone) => {
              return (
                <IonItem
                  detail
                  key={zone}
                  onClick={() => onSelected(zone)}
                  style={{cursor: "pointer"}}
                >
                  <IonLabel>{zone}</IonLabel>
                </IonItem>
            )}
          )}
        </IonItemGroup>
      </IonList>
    </>
  )
}


export { TimezoneSelector }